/**
 * Liste des descripteurs BOAMP (mots-clés officiels)
 * Source: https://boamp-datadila.opendatasoft.com/api/explore/v2.1/catalog/datasets/boamp/facets?facet=descripteur_libelle
 */
export const BOAMP_DESCRIPTORS = [
  'Abris',
  'Aire de jeux',
  'Alimentation en eau potable',
  'Amiante (désamiantage)',
  'Articles de bureau et articles scolaires',
  'Ascenseur',
  'Assainissement',
  'Assistance à maîtrise d\'ouvrage',
  'Assistance technique',
  'Assurance',
  'Audit',
  'Bardage',
  'Bâtiment',
  'Bâtiments modulaires',
  'Bois',
  'Canalisations',
  'Carburant, hydrocarbure',
  'Carrelage',
  'Charpente',
  'Chauffage (exploitation, entretien)',
  'Chauffage (travaux)',
  'Climatisation',
  'Cloison, faux plafond',
  'Clôture',
  'Collecte sélective',
  'Communication',
  'Consommable informatique',
  'Consommables médicaux',
  'Contrôle technique',
  'Couverture',
  'Cuisine (équipement)',
  'Déchets non ménagers (prestations)',
  'Délégation de service public',
  'Démolition',
  'Denrées alimentaires',
  'Eclairage public',
  'Electricité',
  'Electricité (travaux)',
  'Electricité, gaz (fourniture)',
  'Equipement sportif',
  'Equipements spécialisés',
  'Espaces verts',
  'Etanchéité',
  'Etude',
  'Formation',
  'Gardiennage',
  'Génie civil',
  'Gros oeuvre',
  'Habillement',
  'Impression',
  'Informatique (assistance)',
  'Informatique (maintenance serveurs et réseaux)',
  'Informatique (matériel)',
  'Informatique (prestations de services)',
  'Ingénierie',
  'Isolation',
  'Laboratoire (matériel)',
  'Location (matériels)',
  'Logiciel',
  'Maçonnerie',
  'Maintenance',
  'Maîtrise d\'oeuvre',
  'Matériel électrique',
  'Matériel médical',
  'Menuiserie',
  'Métallerie',
  'Mobilier',
  'Mobilier urbain',
  'Nettoyage de locaux',
  'Ordures ménagères (prestations)',
  'Ouvrage d\'art',
  'Ouvrage d\'infrastructure',
  'Papeterie',
  'Peinture (travaux)',
  'Pièces détachées',
  'Plâtrerie',
  'Plomberie',
  'Plomberie (travaux)',
  'Prestations de services',
  'Produits d\'entretien',
  'Publicité',
  'Repas, traiteur',
  'Réseaux divers',
  'Restauration collective',
  'Revêtements de sols',
  'Revêtements muraux',
  'Sanitaire',
  'Sécurité incendie',
  'Serrurerie',
  'Signalisation',
  'Surveillance',
  'Télécommunications',
  'Terrain de sport',
  'Terrassement',
  'Tous corps d\'état',
  'Transport',
  'Végétaux',
  'Véhicules',
  'Véhicules (acquisition)',
  'Véhicules (location)',
  'Ventilation',
  'Voirie',
  'Voirie et réseaux divers',
] as const;

export type BoampDescriptor = typeof BOAMP_DESCRIPTORS[number];
